import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth.js";
import { Layout } from "../components/Layout.js";
import { Login } from "../features/Login.js";
import { Home } from "../features/Home.js";
import { PreprintsPortal } from "../features/preprints/PreprintsPortal.js";
import { PreprintDetails } from "../features/preprints/PreprintDetails.js";
import { ReviewersPortal } from "../features/reviewers/ReviewersPortal.js";
import { QualityCheckPortal } from "../features/quality-check/QualityCheckPortal.js";
import { OperationsPortal } from "../features/operations/OperationsPortal.js";
import { Spinner } from "../components/ui.js";

export function App(): JSX.Element {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner label="Loading…" />
      </div>
    );
  }

  if (!user) {
    if (location.pathname !== "/login") {
      return <Navigate to="/login" replace />;
    }
    return <Login />;
  }

  if (location.pathname === "/login") {
    return <Navigate to="/" replace />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/preprints" element={<PreprintsPortal />} />
        <Route path="/preprints/:id" element={<PreprintDetails />} />
        <Route path="/reviewers" element={<ReviewersPortal />} />
        <Route path="/quality-check" element={<QualityCheckPortal />} />
        <Route path="/operations" element={<OperationsPortal />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
